<div class="rt-fade">

  <div class="modal-card">
    <span (click)="isOpen = false" class="material-icons modal-close">
      close
    </span>
    <div class="rt-modal-header">Add Medo MITR</div>
    <div class="col-md-12">


      <div class="row">
        <div class="col-md-4 col-sm-4 col-xs-12">
          <div class="form__group field">
            <input type="text" class="form__field"      required />
            <label for="name" class="form__label">Filter</label>
          </div>
        </div>
        <div class="col-md-4 col-sm-4 col-xs-12">
          <div class="form__group field">
            <input type="text" class="form__field"      required />
            <label for="name" class="form__label">Filter</label>
          </div>
        </div>
        <div class="col-md-4 col-sm-4 col-xs-12">
          <div class="form__group field">
            <input type="text" class="form__field"      required />
            <label for="name" class="form__label">Filter</label>
          </div>
        </div>
        <div class="col-md-4 col-sm-4 col-xs-12">
          <div class="form__group field">
            <input type="text" class="form__field"      required />
            <label for="name" class="form__label">Filter</label>
          </div>
        </div>
        <div class="col-md-4 col-sm-4 col-xs-12">
          <div class="form__group field">
            <input type="text" class="form__field"      required />
            <label for="name" class="form__label">Filter</label>
          </div>
        </div>
        <div class="col-md-4 col-sm-4 col-xs-12">
          <div class="form__group field">
            <input type="text" class="form__field"      required />
            <label for="name" class="form__label">Filter</label>
          </div>
        </div>
        <div class="col-md-4 col-sm-4 col-xs-12">
          <div class="form__group field">
            <input type="text" class="form__field"      required />
            <label for="name" class="form__label">Filter</label>
          </div>
        </div>
        <div class="col-md-4 col-sm-4 col-xs-12">
          <div class="form__group field">
            <input type="text" class="form__field"      required />
            <label for="name" class="form__label">Filter</label>
          </div>
        </div>
        <div class="col-md-4 col-sm-4 col-xs-12">
          <div class="form__group field">
            <input type="text" class="form__field"      required />
            <label for="name" class="form__label">Filter</label>
          </div>
        </div>
        <div class="col-md-4 col-sm-4 col-xs-12">
          <div class="form__group field">
            <input type="text" class="form__field"      required />
            <label for="name" class="form__label">Filter</label>
          </div>
        </div>
        <div class="col-md-4 col-sm-4 col-xs-12">
          <div class="form__group field">
            <input type="text" class="form__field"      required />
            <label for="name" class="form__label">Filter</label>
          </div>
        </div>
        <div class="col-md-4 col-sm-4 col-xs-12">
          <div class="form__group field">
            <input type="text" class="form__field"      required />
            <label for="name" class="form__label">Filter</label>
          </div>
        </div>
      </div>
    </div>


    <div class="rt-modal-footer">

      <button class="rt-btn">Close</button>

      <button class="rt-btn">Save</button>
    </div>
  </div>
</div>